import { ApiService, apiServiceInstance } from './ApiService';
import { personalDataServiceInstance } from './PersonalDataService';

export class CollectService {
  private apiServiceInstance: ApiService;

  public constructor () {
    this.apiServiceInstance = apiServiceInstance;
  }

  public async sendConsents (ticketCode: string, consents: Record<string, boolean>, siteKey: string, customerUid: string): Promise<void> {
    await Promise.all([
      ...Object.entries(consents)
        .map(([key, value]) => this.apiServiceInstance.sendOptin(ticketCode, key, value)),
      personalDataServiceInstance.saveOptins(siteKey, customerUid, consents),
    ]);
  }

  public async sendPersonalData (ticketCode: string, personalData: Record<string, string>): Promise<void> {
    if (personalData.email !== undefined) {
      await this.apiServiceInstance.sendEmail(ticketCode, personalData.email);
    }
  }
}

export const collectServiceInstance = new CollectService();
